const VIEW = {
  FINDUSER: '/find_user',
  LOGIN: '/login',
  REGISTER: '/register_user',
  ACTIVE: '/activate',
};

export default VIEW;
